module.exports = __webpack_public_path__ + "static/media/cloud2.90834bf1.png";